







import Vue from 'vue';
import { Avatar } from '@/components/ds';

export default Vue.extend({
  components: { Avatar },
  props: {
    email: {
      type: String,
      default: '',
    },
  },
});
